const optionsTimeUnits = [{
  label: 's',
  value: 's'
}, {
  label: 'h',
  value: 'h'
}];

export default optionsTimeUnits;
